import { render, staticRenderFns } from "./giro.vue?vue&type=template&id=3b2a99df&scoped=true"
import script from "./giro.vue?vue&type=script&lang=js"
export * from "./giro.vue?vue&type=script&lang=js"
import style0 from "./giro.vue?vue&type=style&index=0&id=3b2a99df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a99df",
  null
  
)

export default component.exports